import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FurtherAddressesMain.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import FurtherAddressesEditor from './FurtherAddressesEditor/FurtherAddressesEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { AddressTypes } from "../../_loadingHelpers/Address";


class FurtherAddressesMain extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private addressId: string;
    private gDisp: string;

    private store: MdsLax<InstanceType<typeof EntityStore<AddressTypes.FurtherAddressesEntry>>>;

    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private tableContainer: HTMLElement;

    private entryList: Array<AddressTypes.FurtherAddressesEntry> = null;

    constructor(addressId?: string) {
        super(...(arguments as unknown as []));
        if (addressId) this.addressId = addressId;
        else this.addressId = null;
    }

    private emitDataChanged() {

        let data = this.store.getDiffData();

        this.emit("FurtherAddresses_DataChanged", data);
    }

    private _onChange_StoreData() {
    }
        
    private refreshData() {

        this.updateTable();
    }

    private _onClick_EditBtn(rowGr: StaticTable.StaticTableRowGroup<AddressTypes.FurtherAddressesEntry>) {

        let entityId = rowGr.entity.ID;
        this.openEditor(entityId, rowGr.entity.isNew);
    }
    private _onTableRowClick(row: StaticTable.StaticTableRow<AddressTypes.FurtherAddressesEntry>) {

        let entityId = row.rowGroup.entity.ID;
        this.openEditor(entityId, row.rowGroup.entity.isNew);                
    }

    private openEditor(entityId: string, isNew: boolean) {        

        this.StandbyStart();
        if (isNew) {

            this.prepareDocumentEditor(entityId);
            return;
        }
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_FurtherAddresses_GetFurtherAddressDataByID",
            { entityId: entityId },
            lang.hitch(this, this.prepareDocumentEditor, entityId),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }

    private getData() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_FurtherAddresses_GetFurtherAddressesListTableFromAddress",
            { ID: this.addressId },
            lang.hitch(this, this._setUpData),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }

    private _setUpData(response: { entryList: Array<AddressTypes.FurtherAddressesEntry>, tableLayout: { layouts: Array<any> } }) {
        if (this.table != null) this.table.destroy();

        this.store = new EntityStore();

        this.store.setup(response.entryList, "ID");
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);

        this.table.setLayout(response.tableLayout.layouts[0]);
        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClick_EditBtn))
        this.table.addDefaultRowActionButton("delete", lang.hitch(this, this.deleteFurtherAddress));

        this.table.setCyAttribute("furtherAddressesMain");

        this.entryList = response.entryList;

        this.updateTable();
        this.StandbyStop();
    }

    private deleteFurtherAddress(rowGr: StaticTable.StaticTableRowGroup<AddressTypes.FurtherAddressesEntry>) {

        let entry = rowGr.entity;

        if (entry.isNew) {

            this.store.deleteEntry(entry);
        }
        this.updateTable();
        this.emitDataChanged();
    }

    private addNewAddressEntry(): string {
        
        let newId = (Math.random() * 100000).toString();
        let fakeNewEntry: Partial<AddressTypes.FurtherAddressesEntry> = {
            ID: newId,
            isNew: true,
        }
        this.store.addEntry(fakeNewEntry as any, "new");
        return newId;
    }

    private _onClick_NewAddress(ev: Event) {
        
        let entityId = this.addNewAddressEntry();
        this.prepareDocumentEditor(entityId);
        
    }

    private prepareDocumentEditor(entityId, response?) {
        this.StandbyStop();

        let form = new FurtherAddressesEditor();
        let heading = "";

        form.setAddressId(this.addressId);

        if (response) {
            form.setData(response);
            heading = response["$Displayname"];
        } else {
            form.setNewEntityId(entityId);

            form.setStartupState("ready");
            heading = this.translate(`AddressWizard__addLocation`);
        }

        if (this.store.isEntityExisting(entityId, "ID", true)) form.applyAllreadyChangedData(this.store.getEntityById(entityId));


        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        dlg.show(form,
            heading,
            null,
            null,
            "ok",
            (result) => {
                if (result === 1) form.externalEventHandler("ok");
                else {
                    if (this.store.isEntityNew(entityId)) {
                        this.store.deleteEntry(entityId);
                    }
                    dlg.close();
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false
            });

        form.on("okClicked", (data: { ID: string, changedData: Object }) => {

            let existingEntry: AddressTypes.FurtherAddressesEntry = null;
            
            if (this.store.isEntityExisting(data.ID, "ID", true)) {

                existingEntry = this.store.getEntityById(data.ID);

                for (let p in data.changedData) {

                    switch (p) {
                        case "c_postal_code":
                        case "c_city":
                            //
                            break;
                        case "hintbox_city":
                        case "hintbox_postal_code":
                            let attrName = p.replace("hintbox", "c");

                            if (typeof data.changedData[p] == "string") {

                                if (data.changedData[p] != existingEntry[attrName]) existingEntry[attrName] = data.changedData[p];
                                existingEntry.ref_postal_code = null;

                            } else {

                                if (data.changedData[p].ID != existingEntry.ref_postal_code?.ID) {
                                    existingEntry.ref_postal_code = data.changedData[p];
                                    existingEntry.c_postal_code = data.changedData[p].postal_code;
                                    existingEntry.c_city = data.changedData[p].city;
                                    existingEntry.ref_country = data.changedData[p].ref_country;
                                }
                            }
                            break;
                        default:
                            if (data.changedData[p] != existingEntry[p]) existingEntry[p] = data.changedData[p];
                    }
                    
                }
            }

            this.store.changeEntry(existingEntry, true);
            this.updateTable();
            dlg.close();

            this.emitDataChanged();
        })
    }

    private updateTable() {

        this.table.setupFromStore(this.store);
        this.emit("FurtherAddresses_TableUpdate", this.entryList.length > 0);

        this.entryList?.forEach(d => {
            if (d.toDelete === true) {
                this.disableNode(this.table.getRowGroupByKeyValue(d.ID, "ID").rows[0].node);
            }
        });
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.getData();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FurtherAddressesMain);